import { useState } from "react";
import { IPersonBadge } from "../../../../../../common/types";

export const useDeactivateDialog = () => {
  const [isDeactivateDialogOpened, setIsDeactivateDialogOpened] = useState(false);
  const [badgesToDeactivate, setBadgesToDeactivate] = useState<IPersonBadge[]>([]);

  const closeDeactivateDialog = () => {
    setIsDeactivateDialogOpened(false);
  }

  const openDeactivateDialog = (badges: IPersonBadge[]) => {
    setIsDeactivateDialogOpened(true);
    setBadgesToDeactivate(badges)
  }

  return { isDeactivateDialogOpened, openDeactivateDialog, closeDeactivateDialog, badgesToDeactivate }
}
